import { useLayoutEffect } from 'react';
import { type IEmbedHoudini } from '@/types/IEmbeds';

export default function Houdini ({
  frameItemsCount = 6,
  frameTool = 'native-galleries',
  id,
}: IEmbedHoudini) {
  const FRAME_SCRIPT_URL = 'https://c2c24.pl/init/frames.js';

  const isFrameScriptExists = document.querySelector(`script[src="${FRAME_SCRIPT_URL}"]`) !== null;
  if (!isFrameScriptExists) {
    const script = document.createElement('script');
    script.src = FRAME_SCRIPT_URL;
    script.async = true;
    document.body.appendChild(script);
  }

  useLayoutEffect(() => {
    document.dispatchEvent(new Event('liveArticleUpdated'));
  }, []);

  return (
    <div className='houdini-embed'>
      <script data-frameid={id} data-items={frameItemsCount} data-tool={frameTool} />
    </div>
  );
}
